import {Injectable, signal, OnDestroy, Inject, PLATFORM_ID} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeviceService implements OnDestroy {
  isMobile = signal<boolean>(false);
  private resizeListener: (() => void) | undefined;
  // Observer per monitorare la dimensione del web component se necessario,
  // ma per ora manteniamo la logica globale window.innerWidth che è standard per Bootstrap

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
      this.resizeListener = () => this.checkScreenSize();
      window.addEventListener('resize', this.resizeListener);
    }
  }

  private checkScreenSize(): void {
    // Consideriamo mobile se la larghezza è inferiore a 768px (breakpoint md di Bootstrap)
    // Nota: In un Web Component, questo controlla la viewport del browser, non la larghezza del componente.
    // Se il componente è in un container piccolo su uno schermo grande, isMobile sarà false.
    // Per un comportamento responsive basato sul contenitore servirebbe ResizeObserver sull'host element.
    this.isMobile.set(window.innerWidth < 768);
  }

  ngOnDestroy(): void {
    if (this.resizeListener && isPlatformBrowser(this.platformId)) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }
}





